export default __webpack_public_path__ + "static/media/remote-video-left-right.7a048e0d.png";